export default __webpack_public_path__ + "media/images/mail/telegram-f4493383b8868e16d0c67ec53782db8a.png";